import React from "react";
import { DialogFrame, useDialog } from "./dialog-base";
import IconButton from "../LogoButton/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

interface ApprovalConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onApprove: () => void;
  logoTitle: string;
}

export const ApprovalConfirmationDialog: React.FC<
  ApprovalConfirmationDialogProps
> = ({ open, onClose, onApprove, logoTitle }) => {
  const dialogOption = {
    isOpen: open,
    openDialog: () => {},
    closeDialog: onClose,
  };

  return (
    <DialogFrame dialogOption={dialogOption} onClose={onClose}>
      <div className="p-6 space-y-4">
        <h2 className="text-lg font-semibold">Approval Required</h2>
        <div className="space-y-4">
          <p className="text-sm">
            You need to approve "{logoTitle}" before you can send a preview.
          </p>
          <p className="text-sm">
            Would you like to approve it now and continue with sending the
            preview?
          </p>
        </div>
        <div className="flex gap-2 justify-between">
          <IconButton
            variant="dim"
            onClick={onClose}
            icon={<FontAwesomeIcon icon={faXmark} />}
          >
            Cancel
          </IconButton>
          <IconButton
            variant="success"
            onClick={onApprove}
            icon={<FontAwesomeIcon icon={faCheck} />}
          >
            Approve
          </IconButton>
        </div>
      </div>
    </DialogFrame>
  );
};
